const handleFetchcalendarFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.calendarList = action.payload.data;
  state.message = action.payload.message;
};

const createCalendarTaskFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.taskDetail = action.payload.data;
};

const viewalendarTaskFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.taskDetail = action.payload.data;
};

export {
  handleFetchcalendarFulfilled,
  createCalendarTaskFulfilled,
  viewalendarTaskFulfilled,
};
